export type PrayerName = "Fajr" | "Sunrise" | "Dhuhr" | "Asr" | "Maghrib" | "Isha";

export type CalcSettings = {
  method: "MuslimWorldLeague" | "MoonsightingCommittee" | "Egyptian" | "Karachi" | "NorthAmerica" | "UmmAlQura" | "Dubai" | "Qatar" | "Kuwait" | "Singapore" | "Turkey" | "Tehran";
  madhab: "Shafi" | "Hanafi";
  highLatitudeRule: "MiddleOfTheNight" | "SeventhOfTheNight" | "TwilightAngle";
  adjustments: Partial<Record<PrayerName, number>>;
};

export const DEFAULT_SETTINGS: CalcSettings = {
  method: "MuslimWorldLeague",
  madhab: "Shafi",
  highLatitudeRule: "TwilightAngle",
  adjustments: { Fajr: 0, Sunrise: 0, Dhuhr: 0, Asr: 0, Maghrib: 0, Isha: 0 },
};

export enum Language {
  EN = 'en',
  FI = 'fi',
  AR = 'ar',
  ES = 'es',
  FR = 'fr',
  TR = 'tr'
}

export interface LocationData {
  latitude: number;
  longitude: number;
  city: string;
}

export interface PrayerTime {
  name: string;
  time: string;
  id: string;
}

export interface TodayPrayerTimes {
  fajr: string;
  sunrise: string;
  dhuhr: string;
  asr: string;
  maghrib: string;
  isha: string;
}

export interface NextPrayerInfo {
  name: string;
  time: string;
}
